<template>
    <div>
        <div>
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    App Version:
                    <select v-model.number="retObj.appVersion" class="form-control">
                        <option value="">Please Select</option>
                        <option value="AppStartVersion1">Version 1</option>
                        <option value="AppStartVersion2">Version 2 (Listing column on left)</option>
                    </select>
                    Layout Name:
                    <select v-model.number="retObj.layoutName" class="form-control">
                        <option value="">Please Select</option>
                        <!-- <option value="LayoutVersion1">Version 1</option>
                        <option value="LayoutVersion2">Version 2</option> -->
                        <option value="LayoutVersion3">Version 3</option>
                    </select>                  
                    Listing Card:
                    <select v-model.number="retObj.listingCard" class="form-control">
                        <option value="">Please Select</option>
                        <option value="ImageCard">Image Card</option>
                        <option value="InfoCard"> Info Card</option>
                        <option value="MediaCard">Media Card</option>
                        <option value="TextCard">Text Card</option>
                    </select>                  
                    Background:
                    <input class="form-control" type="text" v-model="retObj.background" />
                </div>
                <div class="col-xs-12 col-md-4">
                    {{retObj}}
                </div>
            </div>
        </div>
        <div><input type="button" class="btn btn-default" @click="save"  value="Done"/></div>
    </div>
</template>
<script>
    import modalX from '../components/base/ModalX.vue';

    export default {
        components: {
            modalX: modalX
        },
        props: ["shopUserId","initData"],
        data: function () {
            return {
                retObj: this.initData === null ? {} : this.initData
            };
        },
        methods: {
            save: function () {
                this.$emit("onsave", this.retObj);
            }
        },
        created: function () {

        },
        mounted: function () {
            console.log("jsonData userid", this.shopUserId);
        },
        destroyed: function () {
        }
    }
</script>